import "./styles.css";
import CircularProgress from "@mui/material/CircularProgress";
function LoadingBox() {
  return (
    <div className="LoadingBox">
      <CircularProgress style={{ color: "#1e88e5" }} />
      <br />
      <div>Loading . . .</div>
    </div>
  );
}
export default LoadingBox;
